export function getColorHex(colorName: string): string {
  if (!colorName || colorName.trim() === "") {
    return "#FFFFFF";
  }

  const colorMap: { [key: string]: string } = {
    white: "#FFFFFF",
    orange: "#FFA500",
    red: "#FF0000",
    green: "#00FF00",
    blue: "#0000FF",
    yellow: "#FFFF00",
    black: "#000000",
    gray: "#808080",
    grey: "#808080"
  };

  const normalizedColor = colorName.toLowerCase().trim();
  const hexColor = colorMap[normalizedColor];

  if (colorName.startsWith("#")) {
    return colorName;
  }

  return hexColor || "#FFFFFF";
}
